<template>
  <div class="about">
    <h1>This is blog page</h1>
  </div>
</template>
